import { render, staticRenderFns } from "./pre_textarea.vue?vue&type=template&id=19440192&scoped=true"
import script from "./pre_textarea.vue?vue&type=script&lang=js"
export * from "./pre_textarea.vue?vue&type=script&lang=js"
import style0 from "./pre_textarea.vue?vue&type=style&index=0&id=19440192&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19440192",
  null
  
)

export default component.exports